import { Grid } from '@mui/material';

import { FormAutocompleteField, FormNumberField, FormTextField } from '../../components';
import { SIBLING_RELATIONSHIP_OPTIONS } from '../constants';

import type { ClientSiblingFieldsProps } from './types';

export default function ClientSiblingFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: ClientSiblingFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Sibling relation"
          name="sibling_relationship"
          onChange={saveField}
          options={SIBLING_RELATIONSHIP_OPTIONS}
          placeholder="Select a relationship"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Age"
          min={0}
          name="sibling_age"
          onBlur={saveField}
          placeholder="Enter age"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Diagnosis"
          name="sibling_diagnosis"
          onBlur={saveField}
          placeholder="Enter diagnosis"
          readOnly={readOnly}
          required
        />
      </Grid>
    </Grid>
  );
}
